// extracted by mini-css-extract-plugin
module.exports = {"chart-type-selector":"c_d"};